'use client';

import { useState } from 'react';
import styles from './StudentLoginModal.module.scss';

const OPTIONS = [
  { id: 'degree', label: 'Degree', url: "https://amigo.amityonline.com/login/index.php" },
  { id: 'certificate', label: 'Certificate', url: "https://learn.amigolms.com/login/index.php" }
];

interface Props {
  onClose: () => void;
}

export default function StudentLoginModal({ onClose }: Props) {
  const [selected, setSelected] = useState('degree');

  function handleSubmit() {
    const option = OPTIONS.find((o) => o.id === selected);
    if (option) window.location.href = option.url;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button
          className={styles.closeBtn}
          type="button"
          aria-label="Close"
          onClick={onClose}
        >
          &#x2715;
        </button>

        <h2 className={styles.modalTitle}>Student Login</h2>

        <div className={styles.radioGroup}>
          {OPTIONS.map((option) => (
            <label
              key={option.id}
              className={`${styles.radioCard} ${selected === option.id ? styles.radioCardActive : ''}`}
            >
              <input
                type="radio"
                name="loginOption"
                value={option.id}
                checked={selected === option.id}
                onChange={() => setSelected(option.id)}
                className={styles.radioInput}
              />
              <span className={styles.radioDot} />
              <span className={styles.radioLabel}>{option.label}</span>
            </label>
          ))}
        </div>

        <button className={styles.submitBtn} type="button" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
}
